var labels = {
  domain: {
    en: "Domain",
    es: "Dominio"
  },
  projects: {
    nivel: 2,
    title: {
      es: 'Gestión de Chatbot',
      en: 'Chatbot Management'
    },
    project_description: {
      es: 'Gestiona tus chatbots.',
      en: 'Chatbot Management.'
    },
    create_project: {
      es: 'Crear Chatbot',
      en: 'New Chatbot'
    },
    update_project: {
      es: 'Actualizar Chatbot',
      en: 'Update Chatbot'
    },
    view_project: {
      es: 'Ver Chatbot',
      en: 'View Chatbot'
    },
    business_case: {
      es: 'Caso de Negocio',
      en: 'Business Case'
    },
    name: {
      es: 'Nombre Proyecto',
      en: 'Project Name'
    },
    description: {
      es: 'Descripción',
      en: 'Description'
    },
    private_access: {
      es: 'Acceso Privado',
      en: 'Private Access'
    },
    permissions: {
      es: 'Permisos',
      en: 'Permissions'
    },
    datastore: {
      es: 'Almacen de Datos',
      en: 'Data Store'
    },
    search_section: {
      es: '¿Habilitar seccion de búsqueda?',
      en: 'Search section enabled'
    },
    datastore_search: {
      es: 'Datos para búsqueda',
      en: 'Search Data'
    },
    connections: {
      es: 'Canales',
      en: 'Channels'
    },
    bot: {
      es: 'Bot',
      en: 'Bot'
    },
    assistant_name: {
      es: 'Nombre Asistente',
      en: 'Assistant Name'
    },
    assistant_role: {
      es: 'Rol Asistente',
      en: 'Assistant Role'
    },
    company_name: {
      es: 'Nombre Compañia',
      en: 'Company Name'
    },
    company_activity: {
      es: 'Actividad Compañia',
      en: 'Company Activity'
    },
    conversation_purpose: {
      es: 'Propósito de la Conversación',
      en: 'Conversation Purpose'
    },
    temperature: {
      es: 'Temperatura',
      en: 'Temperature'
    },
    model_name: {
      es: 'Nombre de Modelo',
      en: 'Model Name'
    },
    k_top_retrieval: {
      es: 'K-Top Retrieval',
      en: 'K-Top Retrieval'
    },
    max_token_history: {
      es: 'Max Token History',
      en: 'Max Token History'
    },
    k_top_history: {
      es: 'K-Top History',
      en: 'K-Top History'
    },
    max_minutes: {
      es: 'Max Minutes',
      en: 'Max Minutes'
    },
    created_user: {
      es: 'Usuario',
      en: 'User'
    },
    created_date: {
      es: 'Fecha Creación',
      en: 'Created Date'
    },
    actions: {
      es: 'Acciones',
      en: 'Actions'
    },
    agent_description: {
      es: "Gestiona tus agentes",
      en: "Agent Management"
    },
    title_agent: {
      es: "Gestión de Agentes",
      en: "Agent Management"
    },
    name_agent: {
      es: "Nombre de Agente",
      en: "Agent Name"
    },
    agent_type: {
      es: "Tipo de Agente",
      en: "Agent type"
    },
    env: {
      es: "Entorno",
      en: "Environment"
    },
    change_prod: {
      es: "cambiar a prod",
      en: "Chango to prod"
    },
    create_prod: {
      es: "Versión final",
      en: "Final Version"
    },
    create_dev: {
      es: "Sandbox",
      en: "Test Version"
    },
    chatbot: {
      es: "Chatbot",
      en: "Chatbot"
    }
  },
  hub_ia_migration: {
    nivel: 2,
    title: {
      es: 'AI Hub está en proceso de migración',
      en: 'AI Hub is being migrated'
    },
    subtitle: {
      es: 'Tu empresa tiene habilitadas ambas versiones durante el acompañamiento',
      en: 'Your company has both versions enabled during the transition'
    },
    description: {
      es: 'Elige con cuál quieres trabajar. Puedes cambiar de versión en cualquier momento desde el menú superior.',
      en: 'Choose which one you want to work with. You can switch versions at any time from the top menu.'
    },
    v2_name: {
      es: 'AI Hub V2',
      en: 'AI Hub V2'
    },
    v2_badge: {
      es: 'NUEVA',
      en: 'NEW'
    },
    v2_feature_board: {
      es: 'Tablero de agentes en tarjetas, agrupado por área',
      en: 'Agent board in cards, grouped by area'
    },
    v2_feature_wizard: {
      es: 'Creación guiada en 3 pasos',
      en: 'Guided creation in 3 steps'
    },
    v2_feature_sandbox: {
      es: 'Sandbox de pruebas antes de productivizar',
      en: 'Test sandbox before going to production'
    },
    v2_feature_metrics: {
      es: 'Dashboard de métricas por agente',
      en: 'Metrics dashboard per agent'
    },
    v1_name: {
      es: 'AI Hub V1',
      en: 'AI Hub V1'
    },
    v1_badge: {
      es: 'ACTUAL',
      en: 'CURRENT'
    },
    v1_description: {
      es: 'La versión que estás usando hoy. Sigue disponible durante el proceso de migración.',
      en: 'The version you are using today. It remains available during the migration process.'
    }
  },
  bots: {
    nivel: 2,
    title: {
      es: 'Gestión de Bots',
      en: 'Bots Management'
    },
    chatbot_description: {
      es: 'Gestiona tus Bots aqui.',
      en: 'Bots Management'
    },
    metadata: {
      nivel: 3,
      name: {
        es: 'Nombre',
        en: 'Name'
      },
      description: {
        es: 'Descripción',
        en: 'Description'
      },
      url: {
        es: 'Bot Backend URL',
        en: 'Bot Backend URL'
      },
      url_prd: {
        es: 'Bot Prod Backend URL',
        en: 'Bot Prod Backend URL'
      },
      type_param: {
        es: 'Tipo Parametro',
        en: 'Parameter Type'
      },
      name_param: {
        es: 'Nombre Parametro',
        en: 'Name Parameter'
      },
      shared: {
        es: 'Compartido',
        en: 'Shared'
      },
      value_param: {
        es: 'Valor Parametro',
        en: 'Value Parameter'
      },
      actions: {
        es: 'Acciones',
        en: 'Actions'
      }
    }
  },
  data_center: {
    nivel: 2,
    title: {
      es: 'Centro de Datos',
      en: 'Data Center'
    },
    data_center_description: {
      es: 'Carga tus datos para usarlos en tus conversaciones automatizadas.',
      en: 'Upload your files to use in automate conversations.'
    },
    create_data_center: {
      es: 'Crear Base de Conocimiento',
      en: 'New Knowledge Base'
    },
    update_data_center: {
      es: 'Actualizar Base de Conocimiento',
      en: 'Update Knowledge Base'
    },
    view_data_center: {
      es: 'Ver Base de Conocimiento',
      en: 'View Knowledge Base'
    },
    metadata: {
      nivel: 3,
      name: {
        es: 'Nombre',
        en: 'Name'
      },
      description: {
        es: 'Descripción',
        en: 'Description'
      },
      embedding: {
        es: 'Tipo de Embedding',
        en: 'Embedding Type'
      },
      embedding_source: {
        es: 'Fuente de Embedding',
        en: 'Embedding Source'
      },
      vector_database: {
        es: 'Base de datos Vectorial',
        en: 'Vector Database'
      },
      files: {
        es: 'Archivos',
        en: 'Files'
      },
      file_name: {
        es: 'Archivos',
        en: 'Files'
      },
      file_type: {
        es: 'Archivos',
        en: 'Files'
      },
      file_embedded_column: {
        es: 'Archivos',
        en: 'Files'
      },
      qa: {
        es: 'Preguntas y Respuestas',
        en: 'Questions & Answer'
      },
      qa_question: {
        es: 'Pregunta',
        en: 'Question'
      },
      qa_answer: {
        es: 'Respuesta',
        en: 'Answer'
      },
      created_user: {
        es: 'Usuario',
        en: 'User'
      },
      created_date: {
        es: 'Fecha Creación',
        en: 'Created Date'
      },
      actions: {
        es: 'Acciones',
        en: 'Actions'
      },
      storage_type: {
        es: 'Tipo de almacenamiento',
        en: "Storage Type"
      },
      database: {
        es: "Base de datos Vectorial",
        en: "Vector Database"
      },
      documents_file: {
        es: "Archivo de documentos",
        en: "Documents File"
      },
      database_instance: {
        es: "Intancia de base de datos",
        en: "Database Instance"
      }
    }
  },
  channels: {
    nivel: 2,
    title: {
      es: 'Gestión de Canales',
      en: 'Channels Management'
    },
    channel_description: {
      es: 'Gestiona tus canales.',
      en: 'Channels Management.'
    },
    create_channel: {
      es: 'Crear Canal',
      en: 'New Channel'
    },
    update_channel: {
      es: 'Actualizar Channel',
      en: 'Update Channel'
    },
    view_channel: {
      es: 'Ver Channel',
      en: 'View Channel'
    },
    identity_connection: {
      es: 'Identidad de Conexión',
      en: 'Identity Connection'
    },
    name: {
      es: 'Nombre',
      en: 'Name'
    },
    description: {
      es: 'Descripción',
      en: 'Description'
    },
    type: {
      es: 'Tipo',
      en: 'Type'
    },
    url: {
      es: 'Url',
      en: 'Url'
    },
    account_id: {
      es: 'ID Cuenta',
      en: 'Account ID'
    },
    connection_id: {
      es: 'ID Proveedor',
      en: 'Supplier ID'
    },
    credentials: {
      es: 'Credenciales',
      en: 'Credentials'
    },
    orgs: {
      es: 'Empresa',
      en: 'Org.'
    },
    state: {
      es: 'Estado',
      en: 'State'
    },
    shared: {
      es: 'Compartido',
      en: 'Shared'
    },
    project: {
      es: 'Proyecto',
      en: 'Project'
    },
    metadata: {
      es: 'Metadata',
      en: 'Metadata'
    },
    actions: {
      es: 'Acciones',
      en: 'Actions'
    }
  },
  dashboard: {
    nivel: 2,
    title: {
      es: 'Dashboard',
      en: 'Dashboard'
    },
    dashboard_description: {
      es: 'Herramienta de gestión de la información.',
      en: 'Information management tool.'
    },
    team_members: {
      es: 'Miembros del Equipo',
      en: 'Team Members'
    },
    organization_resources: {
      es: 'Recursos de la Organización',
      en: 'Organization Resources'
    },
    conversations: {
      es: 'Conversaciones',
      en: 'Conversations'
    },
    Indicadores: {
      es: 'Indicadores',
      en: 'Indicators'
    },
    email: {
      es: 'Usuario',
      en: 'User'
    },
    resources: {
      nivel: 3,
      projects: {
        es: 'Total de Projectos',
        en: 'Total Projects'
      },
      datastores: {
        es: 'Total Centro de Datos',
        en: 'Total Data Center'
      },
      connections: {
        es: 'Gestión de Conexiones',
        en: 'Management Connections'
      },
      channels: {
        es: 'Total de Canales',
        en: 'Total channels'
      },
      agents: {
        es: 'Total de Bots',
        en: 'Total Bots'
      },
      total: {
        es: 'Total',
        en: 'Total'
      },
      total_messages: {
        es: 'Total de mensajes',
        en: "Total messages"
      },
      total_sessions: {
        es: 'Total de sesiones',
        en: "Total sessions"
      },
      total_messages_personal: {
        es: "Total de mensajes(personal)",
        en: "Total Messages(Personal)"
      },
      last_session_messages: {
        es: "Mensajes en la última sesión",
        en: "Last session Messages"
      }
    },
    project: {
      es: 'Proyecto',
      en: 'Project'
    },
    user: {
      es: 'Usuario',
      en: 'User'
    },
    range_date: {
      es: 'Seleccione un rango de fechas',
      en: 'Select a date range'
    },
    graphic: {
      es: 'Conversaciones Atendidas',
      en: 'Attended Conversations'
    }
  },
  search_engine: {
    nivel: 2,
    title: {
      es: 'Motores de Búsqueda',
      en: 'Search Engine'
    },
    description: {
      es: 'Descripción del motor de búsqueda',
      en: 'Description Search Engine'
    },
    metadata: {
      nivel: 3,
      type: {
        es: 'Tipo',
        en: 'Type'
      },
      name: {
        es: 'Nombre',
        en: 'Name'
      },
      description: {
        es: 'Descripción',
        en: 'Description'
      },
      secret: {
        es: 'Secreto',
        en: 'Secret'
      },
      actions: {
        es: 'Acciones',
        en: 'Actions'
      }
    }
  },
  config: {
    nivel: 2,
    title: {
      es: 'Configuración de chatbots',
      en: 'Bots Configuration'
    },
    config_description: {
      es: 'Configura tus Chatbots aqui.',
      en: 'Bots Configuration'
    },
    metadata: {
      nivel: 3,
      limit: {
        es: 'Límite',
        en: 'Limit'
      },
      quota: {
        es: 'Cuota mensual($)',
        en: 'Monthly Quota($)'
      }
    }
  }
};
export default labels;